<template>
    <svg aria-hidden="true" focusable="false" width="29" height="22" viewBox="0 0 29 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.31982 6.73492L7.59942 6.73492" class="stroke" stroke-linecap="round" />
        <path d="M1 12.0145L7.59949 12.0145" class="stroke" stroke-linecap="round" />
        <path d="M2.31982 17.2941L8.91931 17.2941" class="stroke" stroke-linecap="round" />
        <path
            d="M19.483 21.2538C18.2097 21.2538 13.4059 15.864 12.078 13.4894C11.3671 12.2318 11 10.7946 11 9.34168C11 4.66276 14.8041 0.850891 19.4908 0.850891C24.1697 0.850891 27.9816 4.65495 27.9816 9.34168C27.9816 10.8336 27.591 12.3021 26.849 13.5832C25.6148 15.7 20.7796 21.2538 19.483 21.2538Z"
            class="stroke fill-active-red"
            stroke-miterlimit="10" />
        <path
            d="M19.483 13.7706C17.0459 13.7706 15.0619 11.7866 15.0619 9.34947C15.0619 6.91237 17.0459 4.92831 19.483 4.92831C21.9201 4.92831 23.9042 6.91237 23.9042 9.34947C23.9042 11.7866 21.9201 13.7706 19.483 13.7706Z"
            class="stroke fill-active-gray"
            stroke-miterlimit="10" />
    </svg>
</template>
